import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

let locked = false

export default {
  lock: target => {
    disableBodyScroll(target, { reserveScrollBarGap: true })
    locked = true
  },

  unlock: target => {
    enableBodyScroll(target, { reserveScrollBarGap: true })
    locked = false
  },

  get locked() {
    return locked
  }
}
